import { parseNotificationMessage } from 'utils/notification';
import moment from 'moment';
import { Common, color } from '@stockbit/ui';
import React, { useMemo } from 'react';
import { useNotificationData } from 'lib/entities/notification/useNotificationData';
import { NotifListContainer, NotifListContent } from './styled';
import NotificationItemImage from './NotificationItemImage';

const { Text, IconWrapper } = Common;

interface NotificationItemContentProps {
  isNew: boolean;
  type: string;
  avatar: string;
  created: string;
  mask: any;
  message: string;
}

function NotificationItemContent({
  isNew,
  type,
  avatar,
  mask,
  message,
  created,
}: NotificationItemContentProps) {
  const closePopup = useNotificationData((store) => store.closePopup);

  const content = useMemo(() => {
    let text = message;
    if (mask) {
      text = parseNotificationMessage({
        mask,
        message,
        renderParseString: (str: string) => str,
        render: (parsedText, tag) => {
          if (tag === 'br') {
            return <br />;
          }

          if (tag === 'b') {
            return <b>{parsedText}</b>;
          }

          if (!parsedText) {
            return parsedText;
          }

          return parsedText;
        },
      });
    }
    return text;
  }, [message]);

  return (
    <NotifListContainer isNew={isNew} onClick={closePopup}>
      <IconWrapper size="30px">
        <NotificationItemImage type={type} avatar={avatar} />
      </IconWrapper>
      <NotifListContent>
        <Text size="13px">{content}</Text>
        <Text size="11px" color={color.midgray} mt="5px">
          {moment(created).fromNow()}
        </Text>
      </NotifListContent>
    </NotifListContainer>
  );
}

export default NotificationItemContent;
